import * as glMatrix from 'gl-matrix';

export class GLMesh {
    _gl: any;
    _vertices: number[];
    _textCoords: number[];
    _indexes: number[];
    _verticesVBO: WebGLBuffer;
    _indexesVBO: WebGLBuffer;
    _texCoordsVBO: WebGLBuffer;
    _model: glMatrix.mat4;
    _modelInverse: glMatrix.mat4;
    primitives: any;
    textCoords: any;
    constructor(gl) {
        var self = this;
        self._gl = gl;
        self.primitives = gl.TRIANGLES;
        self._vertices = [];
        self._textCoords = [];
        self._indexes = [];
        self._verticesVBO = gl.createBuffer();
        self._indexesVBO = gl.createBuffer();
        self._texCoordsVBO = gl.createBuffer();
        self._model = glMatrix.mat4.create();
        self._modelInverse = glMatrix.mat4.create();
    }

    static createRenderQuad(gl) {
        var result = new GLMesh(gl)
        result._vertices = [
            -1, -1, 0,
            -1, 1, 0,
            1, 1, 0,
            1, -1, 0
        ];

        result._textCoords = [
            0, 1,
            0, 0,
            1, 0,
            1, 1
        ];

        result._indexes = [0, 1, 2, 2, 3, 0];

        gl.bindBuffer(gl.ARRAY_BUFFER, result._verticesVBO);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(result._vertices), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, result._texCoordsVBO);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(result._textCoords), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, result._indexesVBO);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(result._indexes), gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);

        return result;
    }

    destroy() {
        var self = this;
        self._gl.deleteBuffer(self._verticesVBO);
        self._gl.deleteBuffer(self._indexesVBO);
        self._gl.deleteBuffer(self._texCoordsVBO);
    }

    get model() {
        return this._model;
    }

    set model(value) {
        var self = this;
        self._model = value;
        glMatrix.mat4.invert(self._modelInverse, self._model);
    }

    get modelInverse() {
        return this._modelInverse;
    }

    addVertice(x, y) {
        var self = this;
        self._vertices.push(x);
        self._vertices.push(y);
        self._vertices.push(0);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._verticesVBO);
        self._gl.bufferData(self._gl.ARRAY_BUFFER, new Float32Array(self._vertices), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, null);
    }

    moveVertice(x, y, index) {
        var self = this;
        self._vertices[index - 1] = y;
        self._vertices[index - 2] = x;
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._verticesVBO);
        self._gl.bufferData(self._gl.ARRAY_BUFFER, new Float32Array(self._vertices), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, null);
    }

    getVertice(index) {
        var self = this;
        return {
            x: self._vertices[index - 2],
            y: self._vertices[index - 1]
        }
    }

    addIndex(index) {
        var self = this;
        self._indexes.push(index);
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, self._indexesVBO);
        self._gl.bufferData(self._gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(self._indexes), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, null);
    }

    rebuild() {
        var self = this;
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._verticesVBO);
        self._gl.bufferData(self._gl.ARRAY_BUFFER, new Float32Array(self._vertices), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, null);
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, self._indexesVBO);
        self._gl.bufferData(self._gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(self._indexes), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, null);
    }

    clear() {
        var self = this;
        self._vertices = [];
        self._textCoords = [];
        self._indexes = [];
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._verticesVBO);
        self._gl.bufferData(self._gl.ARRAY_BUFFER, new Float32Array(self._vertices), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._texCoordsVBO);
        self._gl.bufferData(self._gl.ARRAY_BUFFER, new Float32Array(self._textCoords), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, null);
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, self._indexesVBO);
        self._gl.bufferData(self._gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(self._indexes), self._gl.STATIC_DRAW);
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, null);
    }

    bind(program) {
        var self = this;
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, self._indexesVBO);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._verticesVBO);
        var position = program.attributeLocation('position');
        self._gl.vertexAttribPointer(position, 3, self._gl.FLOAT, false, 0, 0);
        self._gl.enableVertexAttribArray(position);
        var textCoord = program.attributeLocation('textCoord');
        if (textCoord != -1) {
            self._gl.bindBuffer(self._gl.ARRAY_BUFFER, self._texCoordsVBO);
            self._gl.vertexAttribPointer(textCoord, 2, self._gl.FLOAT, false, 0, 0);
            self._gl.enableVertexAttribArray(textCoord);
        }
    }

    draw() {
        var self = this;
        if (self._indexes.length < 3 && self.primitives == self._gl.TRIANGLES) {
            return;
        }

        self._gl.drawElements(self.primitives, self._indexes.length, self._gl.UNSIGNED_SHORT, 0);
    }

    unbind(program) {
        var self = this;
        self._gl.bindBuffer(self._gl.ELEMENT_ARRAY_BUFFER, null);
        self._gl.bindBuffer(self._gl.ARRAY_BUFFER, null);
        self._gl.disableVertexAttribArray(program.attributeLocation('position'));
        if (self.textCoords) {
            self._gl.disableVertexAttribArray(program.attributeLocation('textCoord'));
        }
    }

}